import React from 'react';
//------------------------------------------------------------------
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { FadeInImage } from '../../../../../../components/FadeInImage';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import { useVerifyIsMobile } from '../../../../../../hooks/useVerifyIsMobile';
import { useNavigate } from 'react-router-dom';
import { getRegion } from '../../../../../../utils/Region';
import './style.scss';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';

export const ExpandedVerticalCard = ({ contentInfo, carouselTitle, contentPosition }) => {
  const { isMobile } = useVerifyIsMobile(768);
  const { renderLabel } = useRenderChapas();
  const { nodesSelected } = useMenuRedirect();
  const navigate = useNavigate();

  const handleCardClick = e => {
    e.stopPropagation();

    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    //Redireccionamiento
    navigate(
      `/${getRegion()}/vcard/homeuser/${getContentListV1.titleUri(contentInfo)}/${
        contentInfo?.id
      }`,
    );
  };
  return (
    <div className="expanded-vertical-card" onClick={handleCardClick}>
      {' '}
      {renderLabel(contentInfo)}
      <FadeInImage
        imageAlt={'clarovideo'}
        imageSrc={getContentListV1?.getImage(contentInfo, IMG_SIZE?.VERTICAL)}
        width={isMobile ? 272 : 267}
        height={isMobile ? 408 : 400}
        classNames={['default-card__image']}
      />
    </div>
  );
};
